import React, { useEffect, useState } from "react";
import client from "../lib/api";

// Zimbabwe / PSL newswire — headlines scraped from Soccer24 (soccer24.co.zw).
// Clicking a headline opens the original article at the source in a new tab.
export function NewsWire({ limit = 8, className = "" }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    client.get("/news/wire").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  if (items === null) return null;
  if (!items.length) return null;

  return (
    <section className={className} data-testid="newswire">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[10px] uppercase tracking-[0.25em] text-ink/40 font-bold">
          Around Zim Football
        </div>
        <span className="text-[10px] uppercase tracking-wide text-ink/30 font-bold">via Soccer24</span>
      </div>
      <div className="space-y-3">
        {items.slice(0, limit).map((a) => (
          <a
            key={a.id || a.link}
            href={a.link}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`newswire-item-${a.id || ""}`}
            className="group flex gap-3 rounded-sm border border-pslborder bg-white p-2.5 hover:border-gold transition-colors"
          >
            {a.image_url && (
              <img
                src={a.image_url}
                alt=""
                loading="lazy"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
                className="w-20 h-16 object-cover rounded-sm flex-shrink-0"
              />
            )}
            <div className="min-w-0">
              <h4 className="font-head font-bold text-sm leading-snug line-clamp-2 group-hover:text-green">
                {a.title}
              </h4>
              <div className="text-[10px] uppercase tracking-wide text-ink/40 mt-1 font-bold">
                {a.published_at ? `${a.published_at} · ` : ""}Read at source →
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
